import { CUSTOMER_TYPES } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(CUSTOMER_TYPES);
    }
}